import React from "react"
import clsx from "clsx"

export default class MessagePresenterGeneral extends React.Component {
	constructor(props) {
		super(props)
  }

  componentDidMount() {
    return $("#message-body").append(this.props.message.body)
  }

  componentDidUpdate (prevProps) {
    if(prevProps.message.body != this.props.message.body) {
      var translatedString = I18n.t('body')
      $("#message-body").empty()
      return $("#message-body").append(`<p id="message-body"><strong>${translatedString}: </strong>` + this.props.message.body + '</p>')
    }
  }

	render() {		
    var tabClasses = clsx({
			'active': this.props.active_tab == 'template',
			'tab-pane': true,
		})

		return (
			<div className={tabClasses} id="template">
        <p>
          <strong>{`${I18n.t('code')}: `}</strong>
          {this.props.message.code}
        </p>
        <p>
          <strong>{`${I18n.t('name')}: `}</strong>
          {this.props.message.name}
        </p>
        <p id="message-body">
          <strong>{`${I18n.t('body')}: `}</strong>

        </p>
        <p>
          <strong>{`${I18n.t('event')}: `}</strong>
          {I18n.t(this.props.message.lifecycle_event)}
        </p>
        <p style={{marginBottom: 0}}>
          <strong>{`${I18n.t('status')}: `}</strong>
          {I18n.t(this.props.message.status)}
        </p>
			</div>
		);
	}
}
